import React from 'react';
import { format } from 'date-fns';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import { Box, Button, IconButton, InputAdornment, Popover, TextField } from '@mui/material';
import DateRangeIcon from '@mui/icons-material/DateRange';

export default function DateRangePick({ range, setRange,fetch }) {
    const today = new Date();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  
  const open = Boolean(anchorEl);
  const formatted = range?.from
    ? range.to
      ? `${format(range.from, 'dd MMM yyyy')} - ${format(range.to, 'dd MMM yyyy')}`
      : `${format(range.from, 'dd MMM yyyy')} - ...`
    : '';

    const handleReset = () => {
        setRange({ from: today, to: today });
        handleClose();
    };

  return (
    <>
      <TextField
        label="Select date range"
        value={formatted}
        onClick={handleOpen}
        fullWidth
        readOnly
        InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={handleOpen}>
                  <DateRangeIcon />
                </IconButton>
              </InputAdornment>
            ),
        }}
      />
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box sx={{ p: 2 }}>
        <DayPicker
          mode="range"
          selected={range}
        //   onSelect={(range) => {
        //     setRange(range);
        //     if (range?.from && range?.to) handleClose(); // close when both selected
        //   }}
          onSelect={setRange}
          numberOfMonths={2}
          pagedNavigation
          disabled={{ after: new Date() }} 
          defaultMonth={new Date(new Date().setMonth(new Date().getMonth() - 1))}
        />
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
            <Button variant="outlined" size="small" sx={{backgroundColor: 'secondary.main',color: 'white',borderColor: 'secondary.main',mr: 1}} onClick={handleReset}>
              Reset
            </Button>

            <Button variant="outlined" size="small" onClick={() => { fetch(); handleClose(); } }>
              Submit
            </Button>
            
          </Box>
        </Box>
      </Popover>
    </>
  );
}
